var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"padding-top":"0.5em"}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24}},[_c('dashboard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }